<div class="nx-margin-bottom-2m">
    <div class="progress_bar">
        <aside>
            <ol class="steps" [attr.data-current-step]="currentStep" [attr.data-total-steps]="steps?.length">
                <li *ngFor="let step of steps; let i = index" class="step default-cursor" [class.active--]="isCurrentStep(i)" [class.bold--]="isBold(i)" [ngClass]="{ 'pointer-cursor': currentStep > i && !step.disable }">
                    <span class="step__dot">
                        <nx-icon name="check"></nx-icon>
                    </span>

                    {{ step.name }}
                </li>
            </ol>
        </aside>
    </div>
</div>
